import axios from "axios";
import { API_URL } from "../constants";
import {
  PointsSnapshot,
  PointsFeedPage,
  PointsTransaction,
  PointsUserProfile,
} from "../types/Points";

export async function fetchMySnapshot(companyId: string): Promise<PointsSnapshot> {
  const res = await axios.get(`${API_URL}/${companyId}/points/me`);
  return res.data as PointsSnapshot;
}

export async function fetchFeed(
  companyId: string,
  options: {
    cursor?: number;
    limit?: number;
    search?: string;
    type?: string;
    amount?: string | number;
  } = {}
): Promise<PointsFeedPage> {
  const params = new URLSearchParams();
  if (options.cursor !== undefined) params.set("cursor", String(options.cursor));
  if (options.limit !== undefined) params.set("limit", String(options.limit));
  if (options.search !== undefined) params.set("search", options.search);
  if (options.type !== undefined) params.set("type", options.type);
  if (options.amount !== undefined) params.set("amount", String(options.amount));
  const qs = params.toString();
  const url = `${API_URL}/${companyId}/points/feed${qs ? `?${qs}` : ""}`;
  const res = await axios.get(url);
  return res.data as PointsFeedPage;
}

export async function giveKudos(
  companyId: string,
  toUserId: string,
  reason: string,
  amount: number = 1
): Promise<{ transaction: PointsTransaction; snapshot: PointsSnapshot }> {
  const res = await axios.post(`${API_URL}/${companyId}/points/give`, {
    toUserId,
    reason,
    amount,
  });
  return res.data as { transaction: PointsTransaction; snapshot: PointsSnapshot };
}

export async function fetchUserProfile(
  companyId: string,
  userId: string,
  recent: number = 10
): Promise<PointsUserProfile> {
  const res = await axios.get(
    `${API_URL}/${companyId}/points/user/${userId}?recent=${recent}`
  );
  return res.data as PointsUserProfile;
}
